import React from "react";
import { FcExpired } from "react-icons/fc";
import { Link } from "react-router-dom";

const PaymentLinkExpired = () => {
  return (
    <>
      <div className="thanks-container">
        <div>
          <div className="icon">
          <FcExpired />
          </div>
          <div className="text-center">
            <h1>Payment Link Expired !</h1>
            {/* <p>We've send the link to your inbox. Lorem ipsum dolor sit, </p> */}
            <Link to="/dashboard/home" className="button">
              Go To Dashboard
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default PaymentLinkExpired;
